<template>
  <div>
    <m-courses-1 :havePagination="true" class="mt-5"/>
  </div>
</template>

<script>

export default {
  name: "Course",
}
</script>